module.exports = __webpack_public_path__ + "productSample.0c8360d4359ed0f49c8a10f68562fc09.csv";